import type { DashboardState } from '../types';

interface Props { state: DashboardState | null; }

export function StatusBadge({ state }: Props) {
  if (!state) {
    return <span className="badge badge-unknown">LOADING</span>;
  }

  // Priority of states: paused > circuit > busy > idle
  if (state.queue && state.queue.pausedUntil) {
    const until = new Date(state.queue.pausedUntil).toLocaleString();
    return <span className="badge badge-paused" title={`Paused until ${until}`}>PAUSED</span>;
  }
  if (state.circuit && state.circuit.consecutive529 >= 2) {
    return <span className="badge badge-circuit">CIRCUIT TRIPPED</span>;
  }
  if (state.queue && state.queue.busy) {
    const issue = state.pid?.issueNumber;
    return (
      <span className="badge badge-busy">
        BUSY{issue ? ` #${issue}` : ''}
      </span>
    );
  }
  return <span className="badge badge-idle">IDLE</span>;
}
